<template>
  <layout title="Verstuurde Pogingen" >
       <main class="relative z-0 flex-1 overflow-y-auto focus:outline-none" tabindex="0">
      <!-- Page title & actions -->
      <div class="px-4 py-4 border-b border-gray-200 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8">
        <div class="flex-1 min-w-0">
          <h1 class="text-lg font-medium leading-6 text-gray-900 sm:truncate">
            Kies een campagne
          </h1>
        </div>
      </div>
      
      <div class="hidden sm:block">
        <div class="inline-block min-w-full align-middle border-b border-gray-200">
          <table class="min-w-full">
            <thead>
              <tr class="border-t border-gray-200">
                <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                  <span class="lg:pl-2">Campage</span>
                </th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-100">
              <tr class="hover:bg-gray-100" v-for="campaign in campaigns.data" :key="campaign.id">
                <td class="px-6 py-3 text-sm font-medium leading-5 text-gray-900 whitespace-nowrap max-w-0">
                  <div class="flex items-center space-x-3 lg:pl-2">
                    <div class="flex-shrink-0 w-2.5 h-2.5 rounded-full bg-red-600" :class="{'bg-green-600' : campaign.hasAttempts }"></div>
                    <a :href="'/attempts/' + campaign.id" class="truncate hover:text-gray-600">
                        {{ campaign.name }}
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <Pagination :links="campaigns.links" :meta="campaigns.meta" class="" />
    </main>
  </layout>
</template>

<script>
  import Layout from '@/Shared/Layout'
import Pagination from '../../Shared/Pagination.vue';

  export default {
      props: {
        campaigns: Object
      },
      components: {
    Layout,
    Pagination
},
      data: () => ({
        optionDropdownId: null,
      }),
      methods: {
        optionDropdown(id) {
          return this.optionDropdownId === id;
        },
        clickOptionDropdown(id) {
          if (this.optionDropdownId === id) {
            this.optionDropdownId = null;
          } else {
            this.optionDropdownId = id;
          }
        },
        checkOpen(campaign) {
          window.open(campaign.links.check, '_blank');
          this.optionDropdownId = null;
        }
      }
  }

</script>
